// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__1cLWg","logo":"MainNavigation_logo__3Aaot","nav":"MainNavigation_nav__V_R3B","active":"MainNavigation_active__1Ap1N"};